import isAllStatesOfPrimaryCountry from "@/helpers/locations/stateOfPrimaryCountry";

interface GetStateQueryConditionsArgs {
  states: string[],
  countries: string[],
}

const getStateQueryConditions = ({ states, countries }: GetStateQueryConditionsArgs): Record<string, string | string[]> => {
  if (isAllStatesOfPrimaryCountry(countries)) {
    return { _in: states };
  }

  return {_ilike: `%${states[0]}%`};
}

export default getStateQueryConditions;